import SearchField from "../SearchField/SearchField";
import SPQSFormGroup from "./SPQSFormGroup";
import useSPQS from "../../hooks/useSPQS";
import useSPQSUndo from "../../hooks/useSPQSUndo";
import useAuth from "../../hooks/useAuth";
import { handleInputSelect, addEdits } from "./utils/inputhandlers";

const QSSPInCharge = ({ clearfield }) => {
  // Load context values
  const { auth } = useAuth();
  const { SPQS, setSPQS, setSPQSData } = useSPQS();
  const { SPQSEdits, editIDSPQS, setEditIDSPQS, undoListSPQS } = useSPQSUndo();

  // Local function to allow shorthand input property for onItemSelect
  const localHandleInputSelect = (item, origin, destination) => {
    handleInputSelect(
      item,
      SPQSEdits,
      editIDSPQS,
      setEditIDSPQS,
      setSPQS,
      setSPQSData,
      addEdits,
      undoListSPQS,
      origin,
      destination
    );
  };
  return (
    <fieldset>
      <legend>In Charge:</legend>
      <div className='form-group'>
        <label>Trader:</label>
        {auth?.role === 2020 ? (
          <SearchField
            required={true}
            searchURL='/api/users/gettraderlist'
            value={SPQS?.trader || ""}
            valueName='trader'
            valueID='traderID'
            style={{ width: "90%" }}
            customplaceholder='Select TIC'
            onItemSelect={(item) => {
              localHandleInputSelect(item, "trader", "trader");
            }}
            clearfield={clearfield}
          />
        ) : (
          <SPQSFormGroup readOnly={true} labelname={"Trader"} inputname={"trader"} />
        )}
      </div>
      <div className='form-group'>
        <label>Traffic:</label>
        <SearchField
          required={true}
          searchURL='/api/users/gettrafficlist'
          value={SPQS?.traffic || ""}
          valueName='traffic'
          valueID='trafficID'
          style={{ width: "90%" }}
          customplaceholder='Select Traffic'
          onItemSelect={(item) => {
            localHandleInputSelect(item, "traffic", "traffic");
          }}
          clearfield={clearfield}
        />
      </div>
    </fieldset>
  );
};

export default QSSPInCharge;
